let API_URL = process.env.REACT_APP_API_URL;

export { API_URL };
export const apiUrl = (...args) => `${API_URL}/${args.join('/')}`;

export default apiUrl;
